<template>
  <div id="custom-checkbox">
    <Checkbox
      :indeterminate="indeterminate"
      :value="checkAll"
      @click.prevent.native="handleCheckAll"
    >
      (All)
    </Checkbox>
    <CheckboxGroup
      v-model="currentValue"
      @on-change="valueChange"
    >
      <Checkbox
        v-for="option in checkGroup"
        :key="option"
        :label="option"
        style="display: block"
      />
    </CheckboxGroup>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    checkGroup: Array,
    value: {
      type: Array,
      default () {
        return []
      }
    }
  },

  data () {
    return {
      currentValue: this.value
    }
  },

  computed: {
    indeterminate () {
      return Boolean(this.currentValue.length && this.checkGroup.length && this.currentValue.length !== this.checkGroup.length)
    },

    checkAll: {
      get: function () {
        return Boolean(this.value.length && this.checkGroup.length && this.value.length === this.checkGroup.length)
      },
      set: function (newValue) {
        newValue ? this.currentValue = this.checkGroup : this.currentValue = []
        this.$emit('input', this.currentValue)
      }
    }
  },

  watch: {
    value (val) {
      this.currentValue = val
    }
  },

  methods: {
    /**
     * Function for the "all" checkbox
     */
    handleCheckAll () {
      this.checkAll = this.indeterminate ? false : !this.checkAll
    },

    /**
     * Debounced Event listener for checkbox value change
     * @param {Array} data updated data from checkbox
     */
    valueChange: _.debounce(function (data) {
      this.currentValue = data
      this.$emit('input', data)
    }, 1000)
  }
}
</script>

<style scoped>
  #custom-checkbox {
    padding: 5px;
  }
</style>
